export default __webpack_public_path__ + "static/media/b2.cbb2931b.png";